import React from 'react';

import styles from './SingleInput.scss';

import keyMapping from 'ub/ui/key-mapping';

class SingleInput extends React.Component {
  constructor(props) {
    super(props);
    this.onFocus = this.onFocus.bind(this);
    this.setInputRef = this.setInputRef.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.textInput.focus();
      this.onFocus();
    }
  }

  onFocus() {
    window.editor.keyController.requestFocus(this.textInput);
  }

  setInputRef(input) {
    this.textInput = input;
  }

  onKeyUp(ev) {
    if (ev.which === keyMapping.RETURN_KEY) {
      this.props.onReturnKey();
    }
  }

  render() {
    return (
      <div className={styles.form}>
        {this.props.title ? <label className={styles.label}>{this.props.title}</label> : ''}
        <input
          id={this.props.id}
          ref={this.setInputRef}
          onFocus={this.onFocus}
          className={styles.input}
          name={this.props.name}
          type={this.props.inputType}
          value={this.props.content}
          onChange={this.props.controlFunc}
          placeholder={this.props.placeholder}
          onKeyUp={this.onKeyUp}
        />
      </div>
    );
  }
}

SingleInput.propTypes = {
  inputType: React.PropTypes.oneOf(['text', 'number', 'email', 'password']).isRequired,
  title: React.PropTypes.string,
  name: React.PropTypes.string,
  controlFunc: React.PropTypes.func,
  content: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.number,
  ]),
  placeholder: React.PropTypes.string,
  autoFocus: React.PropTypes.bool,
  id: React.PropTypes.string,
  onReturnKey: React.PropTypes.func,
};

SingleInput.defaultProps = {
  autoFocus: false,
};

export default SingleInput;



// WEBPACK FOOTER //
// ./src/components/input/components/SingleInput.jsx